import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { ReactComponent as GoBackIcon } from "../../assets/images/icons/GoBackIcon.svg";

const SubDrawerRenderer = ({
  anchorParentRef, // pass the Refernce incase Not in same Component
  open,
  onClose,
  headerText = "Sub Drawer",
  inverseSubDrawer = false,
  headerAction = null,
  children,
  coloredStyle = false,
}) => {
  const drawerRef = useRef(document.createElement("div"));

  useEffect(() => {
    if (!open || !anchorParentRef?.current) return;

    const anchor = anchorParentRef.current;
    const parent = anchor.parentNode;
    const drawerElement = drawerRef.current;

    if (parent && drawerElement && anchor.nextSibling !== drawerElement) {
      parent.insertBefore(drawerElement, anchor.nextSibling);
    }

    return () => {
      if (drawerElement && drawerElement.parentNode && drawerElement.parentNode.contains(drawerElement)) {
        drawerElement.parentNode.removeChild(drawerElement);
      }
    };
  }, [anchorParentRef, open]);

  // Render null if not open
  if (!open) return null;

  const drawerContent = (
    <div
      className={`${inverseSubDrawer ? "min-w-[25vw] max-w-[25vw]  " : "min-w-[20vw] max-w-[20vw] "} h-full flex flex-col ${coloredStyle ? "bg-[#F8FBFF]  border-l border-[#BECBD3]" : "bg-primary-active p-4 border-l border-[#BECBD3]"}`}
    >
      <div
        className={`flex items-center justify-between ${coloredStyle ? "p-[9.6px] border-b border-[#BECBD3]" : "pb-3"}`}
      >
        <div className="flex items-center gap-2">
          {onClose && (
            <span onClick={onClose} className="cursor-pointer">
              <GoBackIcon />
            </span>
          )}
          <p className="text-lg font-poppins text-primary  font-600 capitalize">{headerText}</p>
        </div>
        {headerAction}
      </div>

      <div className="flex flex-col grow gap-2 min-h-0">{children}</div>

      {/* <div className="min-w-[25%] w-[25%] bg-[#F0F4FF] flex flex-col   rounded-lg">
                  <div className="w-full ">
                    <div className="flex gap-3 items-center sticky top-0 bg-[#F1F6F9] z-10 px-3 border-b border-[#BECBD3] py-3">
                      <Close className="cursor-pointer text-gray-500 hover:text-gray-700" onClick={handlePinClick} />
                      <h5 className="font-medium text-[#1D4469] flex items-center text-base">
                        <TiltPin className="mr-2" /> Pinned Notes ({pinnedCount})
                      </h5>
                    </div>
                  </div> */}
    </div>
  );

  if (anchorParentRef?.current) {
    return ReactDOM.createPortal(drawerContent, drawerRef.current);
  }

  // Fallback: just render inline
  return drawerContent;
};

export default SubDrawerRenderer;

// // SubDrawerRenderer.jsx
// import React, { useEffect, useRef } from "react";
// import ReactDOM from "react-dom";
// import { ReactComponent as GoBackIcon } from "../../assets/images/icons/GoBackIcon.svg";

// const SubDrawerRenderer = ({
//   anchorParentRef,
//   onClose,
//   headerText,
//   headerAction,
//   children,
// }) => {
//   const drawerRef = useRef(null);

//   useEffect(() => {
//     if (!anchorParentRef?.current) return;

//     const anchor = anchorParentRef.current;
//     const parent = anchor.parentNode;

//     if (!parent) return;

//     const drawerElement = drawerRef.current;

//     // Insert drawer after anchor element
//     if (drawerElement && anchor.nextSibling !== drawerElement) {
//       parent.insertBefore(drawerElement, anchor.nextSibling);
//     }

//   return () => {
//   const drawerElement = drawerRef.current;
//   if (
//     drawerElement &&
//     drawerElement.parentNode &&
//     drawerElement.parentNode.contains(drawerElement)
//   ) {
//     drawerElement.parentNode.removeChild(drawerElement);
//   }
// };
//   }, [anchorParentRef]);

//   return (
//     <div
//       ref={drawerRef}
//       className="min-w-[20vw] max-w-[20vw] flex flex-col bg-[#F3F5F7] p-4 border-l border-[#BECBD3]"
//     >
//       {/* Header */}
//       <div className="flex items-center justify-between pb-3">
//         <div className="flex items-center gap-2">
//           <span onClick={onClose} className="cursor-pointer">
//             <GoBackIcon />
//           </span>
//           <p className="text-lg font-poppins text-[#1D4469] font-600 capitalize">
//             {headerText}
//           </p>
//         </div>
//         {headerAction && headerAction}
//       </div>

//       {/* Content */}
//       <div className="flex flex-col grow gap-2 min-h-0">{children}</div>
//     </div>
//   );
// };

// export default SubDrawerRenderer;
